import { render } from "./KassensystemMain.vue?vue&type=template&id=123e0eed&scoped=true"
import script from "./KassensystemMain.vue?vue&type=script&lang=js"
export * from "./KassensystemMain.vue?vue&type=script&lang=js"

import "./KassensystemMain.vue?vue&type=style&index=0&id=123e0eed&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123e0eed"]])

export default __exports__